import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import itp3 from "../Images/itp3.png";
import itp1 from "../Images/itp1.png";
import itp from "../Images/itp.png";
import { project_name } from "../Config/config";
import SEO from "../components/SEO";  

export default function CustomerServices() {
  return (
    <>
      <SEO  
        title="AI CRM Services & IT Support Solutions | EnteliPro"
        description="EnteliPro offers AI-powered CRM services for the IT industry. Plan and manage projects, boost customer satisfaction, and leverage analytics for business growth."
        keywords="IT Services, CRM Services, Customer Support, IT Project Management, Customer Satisfaction, CRM Analytics, IT Industry Solutions"
        canonical="https://www.entelipro.com/customer_services"
        ogImage="https://www.entelipro.com/static/media/itp.png"
      />

      <Navbar />
      {/* breadcrumbs */}
      <section className="w3l-inner-banner-main">
        <div className="about-inner inner2">
          <div className="container seen-w3">
            <ul className="breadcrumbs-custom-path">
              <li>
                <Link to="/">
                  Home{" "}
                  <span className="fa fa-angle-right" aria-hidden="true"></span>
                </Link>
              </li>
              <li>
                <Link to="/computer">
                  Computer{" "}
                  <span className="fa fa-angle-right" aria-hidden="true"></span>
                </Link>
              </li>
              <li className="active">Services for IT Industry</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="w3l-content-with-photo-4">
        <div className="content-with-photo4-block">
          <div className="container">
            <div className="cwp4-two row">
              <div className="col-xl-6 cwp4-image ">
                <img
                  src={itp}
                  alt="EnteliPro AI CRM Services for IT Project Management"  
                  className="img-responsive "
                />
              </div>
              <div className="cwp4-text col-xl-6">
                <h1 className="header-name" style={{ fontSize: "2.3rem", fontWeight: "700", marginBottom: "1rem" }}>  
                  Plan & Manage IT Projects with AI CRM
                </h1>
                <p className="para">
                  CRM is the one that handles your work to ease your high
                  efforts. Customer Relationship Management (CRM) can plan and
                  control your crucial projects. It can handle your IT projects
                  too as it can structure your projects, focus on targets,
                  goals, budget, etc from the starting. This is the best way to
                  not meet up with any big issues. You can also watch project
                  status just for a reminder.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="w3l-content-with-photo-4">
        <div className="content-with-photo4-block">
          <div className="container">
            <div className="cwp4-two row">
              <div className="cwp4-text col-xl-6">
                <h2>Boost Customer Satisfaction & Loyalty</h2>  
                <p className="para">
                  CRM users use less features of CRM. If they start focusing on
                  every feature then their work can be done in a great way as
                  well. Every industry keeps its eyeballs on customer support
                  service because the customer is the king for every industry or
                  every sector. {`${project_name}`} for the IT industry is to
                  offer timely and efficient customer support and help to their
                  customers that daily deals with them.
                </p>
              </div>
              <div className="col-xl-6 cwp4-image ">
                <img
                  src={itp1}
                  alt="EnteliPro AI CRM Customer Satisfaction and Loyalty Tools"  
                  className="img-responsive "
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="w3l-content-with-photo-4">
        <div className="content-with-photo4-block">
          <div className="container">
            <div className="cwp4-two row">
              <div className="col-xl-6 cwp4-image ">
                <img
                  src={itp3}
                  alt="EnteliPro AI CRM Analytics and Reporting Dashboard"  
                  className="img-responsive "
                />
              </div>
              <div className="cwp4-text col-xl-6">
                <h2>AI CRM Analytics for IT Industry</h2>  
                <p className="para">
                  {`${project_name}`} process, interpret, and report the data of
                  sales and operations to build a picture of the ideal customer
                  and current performance of operations. This doesn't just
                  enable companies to focus more on which marketing campaigns
                  work, but also they can improve operational efficiency.
                  Employees also generate reports to share internally and with
                  their customers faster, and have to depend less on multiple
                  tools for the same, since all the information becomes
                  available in a single integrated tool.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}